import React from 'react';

const ContactsSection = ({ service }) => {
  return (
    <div className="card">
      <div className="body">         
        <h2 style={{ color: '#757575' }}><strong>Contacts</strong></h2>
        <div className="table-responsive">
          <table className="table table-bordered m-b-0">
            <tbody>
              <tr>
                <th scope="row">Phone Number:</th>
                <td>{service.phone_number}</td>
              </tr>
              <tr>
                <th scope="row">Email </th>
                <td>{service.email}</td>
              </tr>
              <tr>
                <th scope="row">Website </th>
                <td>
                  <a 
                    href={service.website} 
                    target="_blank" 
                    style={{ color: '#007bff', textDecoration: 'underline' }}
                  >
                    {service.website}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ContactsSection; 